/**
 * Phase 20 — Guided estimate wizard: progress header (web).
 *
 * "Step N of M" + a segmented bar so the customer always knows where
 * they are (FR-004, SC-002). Completed segments are gold, the active
 * segment is navy, upcoming segments are muted. Brand tokens by name
 * per Constitution VII.
 */

import type { WizardStep, WizardStepId } from "@starz/shared/wizard";

interface Props {
  steps: readonly WizardStep[];
  currentIndex: number;
  currentStepId: WizardStepId;
  completed: Set<WizardStepId>;
}

export function WizardProgress({ steps, currentIndex, currentStepId, completed }: Props) {
  const total = steps.length;
  return (
    <div>
      <ol className="flex gap-1.5" aria-label="Estimate steps">
        {steps.map((s) => {
          const state =
            s.id === currentStepId ? "active" : completed.has(s.id) ? "done" : "upcoming";
          return (
            <li
              key={s.id}
              aria-current={s.id === currentStepId ? "step" : undefined}
              aria-label={`${s.title}${state === "done" ? " (completed)" : ""}`}
              className={
                "h-1.5 flex-1 rounded-full " +
                (state === "done"
                  ? "bg-starz-gold"
                  : state === "active"
                    ? "bg-starz-off-white"
                    : "bg-starz-off-white/20")
              }
            />
          );
        })}
      </ol>
      <p className="mt-2 text-xs font-semibold uppercase tracking-widest text-starz-off-white/70">
        Step {currentIndex + 1} of {total}
      </p>
    </div>
  );
}
